import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class Banner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        return (
            <div className={styles.BannerContainer}>
                <div className={styles.focus}>
                    <img
                        src="//x0.ifengimg.com/ucms/2021_14/F7A1C26090A55559A220721A2812F43E0E8AAE3A_size237_w1000_h499.jpg"
                        className="trans"
                    />
                    <div className={styles.textBg} />
                    <div className={styles.text}>
                        <h1>从星发现大美中国·归来仍是少年</h1>
                        <p>凤凰网旅游携手李菲儿、李一桐、王菊独家分享故乡记忆。</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Banner);
